import { FC } from 'react';

import { ProductSpecialOffer } from '@telialt/models/src/EshopModel';

import { isGiftSpecialOffer, isSingleSpecialOffer } from '../../model';
import { SPECIAL_OFFERS_TEST_ID } from '../../test-ids';
import {
    useSpecialOfferGiftModalControls,
    useSpecialOfferSingleModalControls,
} from '../../useSpecialOfferModalControls';
import { RectShapedButton } from './RectShapedButton';

export const TriggerSpecialOfferModal: FC<ProductSpecialOffer> = (specialOffer) => {
    const { openModal: openSingleModal } = useSpecialOfferSingleModalControls();
    const { openModal: openGiftModal } = useSpecialOfferGiftModalControls();

    const openModalByType = () => {
        if (isSingleSpecialOffer(specialOffer)) {
            openSingleModal(specialOffer);
        } else if (isGiftSpecialOffer(specialOffer)) {
            openGiftModal(specialOffer);
        } else {
            throw Error('unknown Special Offer Modal type, can be Gift OR Single');
        }
    };

    return (
        <RectShapedButton
            icon={specialOffer.icon}
            onClick={openModalByType}
            data-test={SPECIAL_OFFERS_TEST_ID.OFFER_BTN}
        >
            {specialOffer.title}
        </RectShapedButton>
    );
};
